<template>
  <div class="setting__box">
    <h1>データインポート</h1>
    <p class="alert">{{alert}}</p>
    <div class="loadingbox" v-if="loading">
      <Loading />
    </div>
    <div v-else>
      <p>{{notice}}</p>
      <p>
        <input id="url" type="text" name="poturl" class="ipt" v-model="url" placeholder="シェアURL">
        <input id="password" type="text" name="potpassword" class="ipt" v-model="password" placeholder="シェアパスワード">
      </p>
      <p>{{message}}</p>
      <p>
        <button class="btn flx_ctr" aria-label="import a pot from a potly link." v-on:click="importUrl()" :disabled="url === ''">インポート</button>
      </p>
    </div>
  </div>
</template>

<script>
const faunaSecret = 'fnADp7VGxvACCvDlbofi_CIkKVLmWkQm1xxZi3V2';
import { mapActions } from 'vuex';
import Loading from '@/components/Common/Loading.vue';

export default {
  name: 'ImportPotUrl',
  data(){
    return {
      id: '',
      message: '',
      notice: 'シェアURLとパスワードを入力してください。',
      password: '',
      loading: false,
      alert: ''
    }
  },
  components: {
    Loading
  },  
  computed: {
    url: {
      get: function () {
        return this.id
      },
      // setter 関数
      set: function (val) {
        const match = val.match(/^https?:\/\/potly.net\/tools\/import\//);
        if(match !== null){
          this.id = val.split('/')[5]
        }
      }
    }
  },
  created(){
    this.initData(this.$route)
    this.toggleSpSlide(true)
  },
  watch: {
    '$route' (to) {
      this.initData(to)
    }
  },
  methods: {
    ...mapActions([
      'potDetailsAdd', 'potsAdd', 'toggleSpSlide'
    ]),
    initData: function(route){
      this.loading = false
      this.alert = ''
      if(route.params.id){
        this.id = route.params.id
        this.notice = "下記のインポートIDのPotを取り込みます。"
      }else{
        this.url = ''
        this.notice = 'シェアURLを入力してください。'
      }
    },
    importUrl: async function(){
      this.loading = true
      this.alert = ''
      const data = `
        {
          findDeliverByIDPass(
          id: "${this.id}"
          password: "${this.password}"
          ){
            pot{
              id
              title
              author
              status
              created_at
              updated_at
              details{
                data{
                  id
                  potId
                  text
                  order
                  created_at
                  updated_at
                }
              }
            }
          }
        }
      `

      const potData = await fetch('https://graphql.fauna.com/graphql', {
        headers: { 'Authorization': 'Bearer ' + faunaSecret, 'Content-Type': 'application/json'},
        method: 'POST',
        body:  JSON.stringify({query: data})
      }).then(function(response) {
        return response.json();
      }).then(function(json) {
        // console.log(json);        
        return json.data.findDeliverByIDPass
      });            
      // console.log(potData);
      if(potData !== null){
        const pPara = {}
        pPara.id = potData.pot.id
        pPara.title = potData.pot.title
        pPara.author = potData.pot.author
        pPara.status = potData.pot.status
        pPara.created_at = potData.pot.created_at
        pPara.updated_at = potData.pot.updated_at

        // console.log(pPara);
        await this.potsAdd(pPara)
        .then(async()=>{
          const detailData = potData.pot.details.data
          for(let i in detailData){
            const dPara = {}
            dPara.id = detailData[i].id
            dPara.potId = detailData[i].potId
            dPara.text = detailData[i].text
            dPara.order = detailData[i].order
            dPara.created_at = detailData[i].created_at
            dPara.updated_at = detailData[i].updated_at
            // console.log(dPara);
            await this.potDetailsAdd(dPara)
          }
        })
        .then(()=>{
          this.$router.push({ name: 'PotDetail', params: {id: pPara.id}})
        })
      }else{
        this.alert = 'URLかパスワードが正しくありません。'
        this.loading = false
      }     
    }
  }
}
</script>

<style lang="scss">
.loadingbox{
  position: relative;
  padding: 64px;
}
.alert{
  margin: 16px 0;
  font-weight: bold;
  color: #FF3300;
}
.setting__box{
  padding: 24px;
}
.ipt{
  background: #FFF;
  border: 1px solid #DDD;
  border-radius: 3px;
  padding: 4px 8px;
  width: 100%;
  margin: 8px 0;
}
</style>